export const PIANO_ROLL = "PIANO_ROLL";
export const EFFECTS = "EFFECTS";
